import { useTranslation } from 'react-i18next';
import { PinB } from 'assets/svg';

import { useConfig } from 'core/modules/config';
import { Icon } from 'modules/ui';

const FooterCmp = () => {
  const { config } = useConfig();
  const { t } = useTranslation();
  const keepOnlyNumbersAndPlus = (str: string) => {
    return str.replace(/[^\d+]/g, '');
  };
  const pinBContactEmail =
    config?.company.pinBContactEmail || t('PORTAL.CONTACT.CONTACT_EMAIL')!;
  const pinBContactNumber =
    config?.company.pinBContactNumber || t('PORTAL.CONTACT.CONTACT_NUMBER')!;
  const cleanedNumber = keepOnlyNumbersAndPlus(pinBContactNumber);

  return (
    <footer className="text-neutral-100 primary-gradient pb-4 flex flex-col gap-5">
      <div className="container flex justify-between items-end min-h-10 mb-50">
        <PinB className="h-40 my-4" />
        <div className="flex flex-col">
          <div className="flex items-center">
            <Icon type="envelope" marginRight={4} />
            <a
              href={`mailto:${pinBContactEmail}`}
              className="text-neutral-100 hover:underline"
            >
              {pinBContactEmail}
            </a>
          </div>
          <div className="flex items-center">
            <Icon type="phone" marginRight={4} />
            <a
              href={`tel:${cleanedNumber}`}
              className="text-neutral-100 hover:underline"
            >
              {pinBContactNumber}
            </a>
          </div>
          <div className="flex items-center ">
            {config?.company.openingHoursLine1 ||
              t('PORTAL.CONTACT.WORKING_HOURS')}
          </div>
          <div className="flex items-center ">
            {config?.company.openingHoursLine2 ||
              (config?.company.openingHoursLine1
                ? ''
                : t('PORTAL.CONTACT.WORKING_HOURS_EXTRA'))}
          </div>
          <div className="flex items-center mb-2">
            <Icon type="map-marker-alt" marginRight={4} />
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.google.com/maps/place/Gravendreef+11%2Fbus+6,+9120+Beveren/@51.2108018,4.2574483,17z/data=!3m1!4b1!4m5!3m4!1s0x47c38b34687ae2ef:0x7387807c612af4!8m2!3d51.2108018!4d4.259637"
              className="hover:underline text-neutral-100"
            >
              Gravendreef 11 bus 6, 9120 Beveren
            </a>
          </div>
        </div>
      </div>
      <div className="container flex gap-6 py-2 text-xxs m-1">
        <div>{t('PORTAL.FOOTER.BLOCK_1')}</div>
        <div>{t('PORTAL.FOOTER.BLOCK_2')}</div>
      </div>
    </footer>
  );
};

export default FooterCmp;
